import ajax from "./ajax";

export const findById = params => ajax(`/home/findById`, params,'POST');  // 新闻详情